/* EDUARD-CUSTOM
   Pfeile fuer den Produkt-Slider (sections/eduard-product-slider.liquid).

   Das Wischen selbst macht CSS (scroll-snap). Dieses Skript ergaenzt nur die
   beiden Pfeile: eine Karte weiter, Zustand aktualisieren, und die ganze
   Pfeilzeile ausblenden, wenn gar nichts zu scrollen ist. Ohne JavaScript
   bleibt der Slider bedienbar - dann fehlen nur die Pfeile. */

class EduardProductSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-eps-track]');
    if (!this.track) return;

    this.nav = this.querySelector('[data-eps-nav]');
    this.prev = this.querySelector('[data-eps-prev]');
    this.next = this.querySelector('[data-eps-next]');

    this.onScroll = this.update.bind(this);
    this.track.addEventListener('scroll', this.onScroll, { passive: true });

    if (this.prev) this.prev.addEventListener('click', () => this.move(-1));
    if (this.next) this.next.addEventListener('click', () => this.move(1));

    if ('ResizeObserver' in window) {
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
    } else {
      window.addEventListener('resize', this.onScroll);
    }

    this.update();
  }

  disconnectedCallback() {
    if (this.track && this.onScroll) this.track.removeEventListener('scroll', this.onScroll);
    if (this.observer) this.observer.disconnect();
    window.removeEventListener('resize', this.onScroll);
  }

  slides() {
    return Array.prototype.slice.call(this.track.querySelectorAll('[data-eps-slide]'));
  }

  /* Eine Kartenbreite plus Abstand - aus dem Layout gelesen, nicht geraten,
     damit die Einstellungen aus dem Theme-Editor automatisch gelten. */
  step() {
    const slide = this.track.querySelector('[data-eps-slide]');
    if (!slide) return this.track.clientWidth;
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    return Math.round(slide.getBoundingClientRect().width + gap) || this.track.clientWidth;
  }

  /* Scrollposition einer Karte, unabhaengig davon, welches Element gerade
     offsetParent ist. */
  offsetOf(slide) {
    return Math.round(
      slide.getBoundingClientRect().left -
      this.track.getBoundingClientRect().left +
      this.track.scrollLeft
    );
  }

  /* Ziel ueber den Kartenindex statt ueber scrollBy: bei schnellen Klicks
     oder einer unterbrochenen Animation bleibt der Slider sonst zwischen
     zwei Karten stehen. */
  move(direction) {
    const slides = this.slides();
    if (!slides.length) return;
    const index = Math.round(this.track.scrollLeft / this.step()) + direction;
    const bounded = Math.max(0, Math.min(index, slides.length - 1));
    this.track.scrollTo({ left: this.offsetOf(slides[bounded]), behavior: 'smooth' });
  }

  update() {
    if (!this.track) return;
    const max = this.track.scrollWidth - this.track.clientWidth;
    const scrollable = max > 2;
    if (this.nav) this.nav.hidden = !scrollable;
    if (this.prev) this.prev.disabled = !scrollable || this.track.scrollLeft <= 2;
    if (this.next) this.next.disabled = !scrollable || this.track.scrollLeft >= max - 2;
  }
}

if (!customElements.get('eduard-product-slider')) {
  customElements.define('eduard-product-slider', EduardProductSlider);
}
